<template>
  <div
    class="s-confirmation-form__box s-confirmation-form__box--phone"
    :class="completedClass">
    <Loader v-if="isLoading"></Loader>

    <Alert
      v-if="!isLoading && errorMsgs.length && !hasOtpError"
      key="submit-errors"
      dismiss-by-native=""
      type="danger"
      :messages="errorMsgs"
      @close="removeErrors"></Alert>

    <!--head-->
    <div class="s-confirmation-form__box__head">
      <div class="s-confirmation-form__box__title">{{ formTitle }}</div>
      <div class="s-confirmation-form__box__icon"></div>
    </div>

    <!--body-->
    <div v-if="prevStepCompleted" class="s-confirmation-form__box__body">
      <div class="s-confirmation-form__info">
        {{ dictionary.emailConfirmationDesc }}
        <span>{{ modifiedPhone }}</span>
      </div>

      <OtpInputs
        :has-otp-error="hasOtpError"
        :resend-otp-code="resendOtpCode"
        @reset-form="resetForm"
        @confirm-email-otp="confirmOtp"></OtpInputs>
      <div
        v-if="!isLoading && errorMsgs.length && hasOtpError"
        class="field-validation-error">
        {{ errorMsgs[0] }}
      </div>

      <div class="s-confirmation-form__resend">
        <button type="button" @click="resendOtp">
          {{ dictionary.resendCode }}
        </button>
      </div>

      <button
        type="submit"
        class="p-contact__submit-btn"
        :disabled="isButtonDisabled"
        @click="validateOtp">
        <span>{{ dictionary.btnLabel }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import postRequestHandler from '../../../lib/postRequestHandler'
import getErrorMessage from '../../../lib/getErrorMessage'
import OtpInputs from './../RegisterForm/OtpInputs.vue'
import Loader from '../Shared/Loader.vue'
import Alert from '../Shared/Alert.vue'
// import { hide } from '@popperjs/core'

export default {
  components: { Loader, OtpInputs, Alert },
  props: {
    mobileTelephone: {
      default: '',
      type: String,
    },
    prevStepCompleted: {
      default: false,
      type: Boolean,
    },
    firstName: {
      default: '',
      type: String,
    },
    lastName: {
      default: '',
      type: String,
    },
    showEmailOtp: {
      default: false,
      type: Boolean,
    },
    showTelephoneOtp: {
      default: false,
      type: Boolean,
    },
  },
  emits: ['confirm-email-otp', 'send-phone-otp'],

  data() {
    return {
      isLoading: false,
      errorMsgs: [],
      isButtonDisabled: true,
      completedStep: false,
      otpCode: '',
      hasError: false,
      hasOtpError: false,
      resendOtpCode: false,
      isOpen: true,
    }
  },
  computed: {
    completedClass() {
      return this.completedStep ? 's-confirmation-form__box--completed' : ''
    },

    formTitle() {
      return this.completedStep
        ? this.dictionary.phoneConfirmed
        : this.dictionary.phoneConfirmationTitle
    },

    modifiedPhone() {
      const firstThree = this.mobileTelephone.slice(0, 3)
      const lastThree = this.mobileTelephone.slice(-3)
      const middleDots = '•'.repeat(this.mobileTelephone.length - 6)

      return firstThree + middleDots + lastThree
    },
  },

  methods: {
    resetForm(code) {
      if (code.length === 0) {
        this.hasOtpError = false
        this.errorMsgs = []
      }
      this.isButtonDisabled = true
    },
    confirmOtp(code) {
      this.otpCode = code
      if (this.otpCode.length === 6) {
        this.isButtonDisabled = false
      } else {
        this.isButtonDisabled = true
      }
    },

    async validateOtp() {
      if (this.isLoading) {
        return false
      }

      this.isLoading = true

      const postData = {
        userSessionId: this.configuration.userSessionId,
        phoneOtp: this.otpCode,
        language: document.documentElement.lang,
        phoneOTPRequired: true,
        mobileTelephone: this.mobileTelephone,
        firstName: this.firstName,
        lastName: this.lastName,
      }

      await postRequestHandler({
        postData,
        endpoint: this.configuration.endpointValidatePhoneOtp,
        successCallback: this.handleSuccess,
        errorCallback: this.handleError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.phoneOtpCatpchaAction,
      })
    },

    handleSuccess() {
      this.isLoading = false
      this.errorMsgs = []

      // this.completedStep = true
      //this.isOpen = false
      this.$emit('send-phone-otp')
    },

    async resendOtp() {
      if (this.isLoading) {
        return false
      }

      this.hasError = false
      this.isLoading = true
      this.hasOtpError = false

      const postData = {
        userSessionId: this.configuration.userSessionId,
        language: document.documentElement.lang,
        mobileTelephone: this.mobileTelephone,
        firstName: this.firstName,
        lastName: this.lastName,
      }

      await postRequestHandler({
        postData,
        endpoint: this.configuration.endpointPhoneResendOtp,
        successCallback: this.resendSuccess,
        errorCallback: this.resendhandleError,
        refreshTokenHandler: this.configuration.refresh,
        captchaAction: this.configuration.phoneResendOtpCatpchaAction,
      })
    },

    resendSuccess() {
      this.isLoading = false
      this.errorMsgs = []
      this.resendOtpCode = true
    },

    resendhandleError(messages) {
      this.isLoading = false
      this.hasError = true
      this.errorMsgs = getErrorMessage(
        messages,
        this.dictionary.defaultErrorMessage
      )

      //await this.$nextTick()
      //  lib.scrollToError()
    },

    handleError(messages) {
      this.isLoading = false
      this.hasOtpError = true
      this.errorMsgs = getErrorMessage(
        messages,
        this.dictionary.defaultErrorMessage
      )

      //await this.$nextTick()
      //  lib.scrollToError()
    },

    changePhone() {
      this.$emit('change-data', true)
    },
  },
}
</script>
